import { analyticsIds } from '../../../../constants/analyticsIds';
import { CypressIds } from '../../../../constants/cypressIds';
import { getValidationObject } from '../../../../constants/regexPatterns';

export const formStack = [
  {
    required: true,
    inputName: 'jobName',
    labelName: 'Project Name',
    placeholder: 'Project Name',
    validation: {
      required: { value: true, message: 'Project name is required' },
      minLength: { value: 3, message: 'Project name must have at least three characters' },
      maxLength: { value: 250, message: 'Project name must have fewer than 250 characters' },
      ...getValidationObject('alphaNumericAndCharacters')
    },
    dataAnalyticsId: analyticsIds.projectsListPage.createProjectForm.nameInput,
    cypressId: CypressIds.createProjectTrayProjectNameInput
  },
  {
    required: false,
    inputName: 'jobNumber',
    labelName: 'Project Number',
    placeholder: 'Project Number',
    tooltip: 'Helpful text about adding project number',
    validation: {
      maxLength: { value: 75, message: 'Project number must have fewer than 75 characters' },
      ...getValidationObject('alphaNumericAndCharacters')
    },
    dataAnalyticsId: analyticsIds.projectsListPage.createProjectForm.numberInput,
    cypressId: CypressIds.createProjectTrayProjectNumberInput
  },
  {
    required: false,
    inputName: 'jobDescription',
    labelName: 'Project Description',
    placeholder: 'Project Description',
    type: 'textArea',
    tooltip: 'Helpful text about adding project description',
    dataAnalyticsId: analyticsIds.projectsListPage.createProjectForm.descriptionInput
  }
];

export const dateFormStack = [
  {
    required: false,
    inputName: 'job_start',
    labelName: 'Start Date',
    placeholder: 'MM/DD/YYYY',
    dataAnalyticsId: analyticsIds.projectsListPage.createProjectForm.startDateCalender
  },
  {
    required: false,
    inputName: 'job_end',
    labelName: 'End Date',
    placeholder: 'MM/DD/YYYY',
    dataAnalyticsId: analyticsIds.projectsListPage.createProjectForm.endDateCalendar
  }
];

/**
 * Both Start Date and End Date are optional. An empty value (null, undefined,
 * or empty string) must always be valid on its own — otherwise `null` coerces
 * to `0` in the comparisons below and an empty field can be misread as an
 * inverted range. Ordering is only enforced once both dates are present.
 */
export const validateDates = (value, key, useFormMethods) => {
  if (!value) {
    return true;
  }

  const formValues = useFormMethods.getValues();

  if (key === 'job_start' && formValues.job_end) {
    return value > formValues?.job_end ? 'Start Date must be before End Date' : true;
  }

  if (key === 'job_end' && formValues.job_start) {
    const validEnd = value < formValues?.job_start ? 'End Date must be after Start Date' : true;

    if (typeof validEnd === 'string') {
      useFormMethods.resetField('job_end', { keepError: true });
      useFormMethods.resetField('job_start', { keepError: true });
    }

    return validEnd;
  }
};
